<div class="row">
    <div [ngClass]="(invoiceLine | json) != '{}' ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #uiGrid
                    [data]="gridData"
                    [sort]="gridState.sort"
                    [sortable]="false"
                    [pageable]="false"
                    [filterable]="false"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" width="105">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="searchOrder.invoiceStatusName!='Prepared'&&readonly!=true">
                        <button (click)="edit(dataItem)" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1"><i class="fas fa-pencil-alt"></i></button>
                        <button (click)="delete(dataItem)" *ngIf="canDelete(dataItem)" class="btn btn-sml btn-danger" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Charges">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div>{{dataItem.description}} ({{dataItem.abbrev}})</div>
                    <div>Qty: {{dataItem.quantity}} Rate: {{dataItem.rate > 0 ? (dataItem.rate | currency) : ''}}</div>
                    <div>Total: {{dataItem.invoiceAmount > 0 ? (dataItem.invoiceAmount | currency) : ''}}</div>
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="abbrev" title="Line Type"></kendo-grid-column>
            <kendo-grid-column field="description" title="Description"></kendo-grid-column>
            <kendo-grid-column field="quantity" title="Quantity"></kendo-grid-column>
            <kendo-grid-column field="rate" title="Rate">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.rate > 0 ? (dataItem.rate | currency) : ''}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="invoiceAmount" title="Amount">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.invoiceAmount > 0 ? (dataItem.invoiceAmount | currency) : ''}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isAccessorialCharge" title="Acc?">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.isAccessorialCharge ? 'Yes' : 'No'}}
                </ng-template>
            </kendo-grid-column>-->
        </kendo-grid>
    </div>
    <div class="col-sm-1">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="searchOrder.invoiceStatusName!='Prepared'&&readonly!=true"><i class="fas fa-plus"></i></button>
    </div>
    <div class="col" *ngIf="(invoiceLine | json) != '{}'">
        <invoice-line-form [invoiceLine]="invoiceLine" [pageType]="pageType" (onRefresh)="getInvoiceLines()"></invoice-line-form>
    </div>
</div>
